import { EmailErrorMessage, ContactErrorMessage } from '@general/js/enums/ErrorMessageEnum';
import { ContactNumberType } from '@/enums';

export const getEmailErrorMessage = (email) => {
  if (email.$error && !email.required) {
    return `${EmailErrorMessage.IS_EMPTY} Email address`;
  }
  return EmailErrorMessage.IS_INVALID;
};

export const getContactErrorMessage = (number, type) => {
  // If type is selected but Phone Number is NOT specified or is invalid
  if (type !== '') {
    if (type.toLowerCase() === ContactNumberType.MOBILE && (number === '' || number !== '')) {
      return `${ContactErrorMessage.IS_INVALID_MOBILE}`;
    }
    return ContactErrorMessage.IS_INVALID_OTHERS;
  }

  // If Type is NOT selected
  return `${ContactErrorMessage.IS_EMPTY} for Preferred phone number - Type.`;
};
